import React, { useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import DynamicSwitchBox from 'components/DynamicSwitchGroup/DynamicSwitchBox';
import CodexVersionDisplayBar from 'components/CodexVersionDisplayBar';

import './DynamicSwitchGroupDetails.css';
import { getDynamicSwitchGroup } from './DynamicSwitchGroupDetails.actions';

const DynamicSwitchGroupDetails = () => {
  const dispatch = useDispatch();
  const { dynamicSwitchGroup } = useParams();
  const location = useLocation();

  useEffect(() => {
    if (dynamicSwitchGroup) {
      dispatch(getDynamicSwitchGroup(dynamicSwitchGroup));
  }
  }, [dispatch, dynamicSwitchGroup]);

  const queryParams = new URLSearchParams(location.search);
  const isCodexVersionDisplayBarVisible = !queryParams.get('showDisplayCodexBar');

    return (
      <Container fluid>
      {isCodexVersionDisplayBarVisible ? <CodexVersionDisplayBar /> : null}
        <Row>
          <Col xs={12}>
            <DynamicSwitchBox />
          </Col>
        </Row>
      </Container>
    );
};

export default DynamicSwitchGroupDetails;

